module.exports = __webpack_public_path__ + "img/collection-memoireRingsFullSizeMemoires@2x.881a7b5.jpg";